export const CIRCLE = "circle";
export const CLINIC = "clinic";

